import ElementObserver from "./ElementObserver.js";
import { getIntersectionObservable } from "./Observable.js";
export const getElementObserver = (el, options) => {
  const scrollContainer = getScrollableParent(el);
  const observerOptions = {
    ...getDefaultOptions(scrollContainer),
    ...options
  };
  const test = getIntersectionObservable(observerOptions);
  return new ElementObserver(test, el);
};
const getDefaultOptions = (scrollContainer) => {
  return {
    root: scrollContainer !== window.document.documentElement && scrollContainer || void 0,
    threshold: [0]
  };
};
export const isElementOutViewport = function(el) {
  const rect = el.getBoundingClientRect();
  const node = getScrollableParent(el);
  let parentRect = { left: 0, right: 0, top: 0 };
  if (node && "getBoundingClientRect" in node) {
    parentRect = node.getBoundingClientRect();
  }
  const position = {
    x: rect.left + parentRect.left,
    y: rect.top + parentRect.top
  };
  const rootDimension = {
    x: node?.offsetWidth || window.innerWidth,
    y: node?.offsetHeight || window.innerHeight
  };
  return rect.bottom < 0 || rect.right < 0 || position.x > rootDimension.x || position.y > rootDimension.y;
};
const regex = /(auto|scroll)/;
const style = (node, prop) => getComputedStyle(node, null).getPropertyValue(prop);
const scroll = (node) => regex.test(
  style(node, "overflow") + style(node, "overflow-y") + style(node, "overflow-x")
);
const getScrollableParent = (node, nodes = []) => {
  if (!node || node === document.body) {
    return void 0;
  } else {
    const el = node;
    if ((el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth) && scroll(el)) {
      return el;
    }
    nodes.push(el);
    return getScrollableParent(el.parentNode, nodes);
  }
};
